import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-barbers',
  templateUrl: './barbers.component.html',
  styleUrls: ['./barbers.component.css']
})
export class BarbersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
